import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHotel, faList, faUser, faUtensils } from '@fortawesome/free-solid-svg-icons';
import { RoomsClass } from '../../ts/interfaces/OphirBook';
import { useTranslation } from 'react-i18next';

interface RoomsSummaryProps {
  rooms: RoomsClass[];
}

const RoomsSummary: FC<RoomsSummaryProps> = ({ rooms }) => {
  const [t] = useTranslation() as unknown as [(key: string) => string];
  return (
    <div className="oph-table-sm-wr default-shadow">
      <table className="oph-table-sm oph-table-sm-room">
        <thead>
          <tr>
            <th>
              <FontAwesomeIcon icon={faHotel as any} /> {t('op.room_type')}
            </th>
            <th>
              <FontAwesomeIcon icon={faUtensils as any} /> {t('op.hosting_base')}
            </th>
            <th>
              <FontAwesomeIcon icon={faList as any} /> {t('op.amount')}
            </th>
          </tr>
        </thead>
        <tbody>
          {rooms.map((room, index) => (
            <tr key={index}>
              <td>
                <div>
                  {Array(room.room?.[0].numofPax || 1)
                    .fill('')
                    .map((_, index) => (
                      <span key={index}>
                        <FontAwesomeIcon icon={faUser as any} />{' '}
                      </span>
                    ))}{' '}
                  <span className="text-bold">{room.class.desc}</span>
                </div>
                <div>{room.room?.[0].roomType.desc}</div>
              </td>
              <td>{room.basis.desc}</td>
              <td>1x</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RoomsSummary;
